import { isTMultipleValue } from '../../../../types/components/components.typeGuard';
import { EXCEPTIONS_MESSAGE } from '../../../../configs/error/error.config';

import type { TNameType } from '../../../../types/components/components.type';
import type {
  IAutocompleteHandleChangeContext,
  IAutocompleteHandleChangeValue,
} from './handleChange.util.type';

export const autocompleteHandleChange = <TName extends TNameType>(
  {
    name,
    newValue,
    reason,
    availableValues = [],
    value: currentValue,
  }: IAutocompleteHandleChangeValue<TName>,
  { clearLocalValue, handleChange, setLocalValue }: IAutocompleteHandleChangeContext<TName>,
): void => {
  const defaultValue: never[] = [];
  const defaultValueObj = { key: name, value: defaultValue } as const;

  switch (reason) {
    case 'clear': {
      clearLocalValue();
      handleChange(defaultValueObj, availableValues);

      break;
    }

    case 'localChange': {
      setLocalValue(newValue);

      break;
    }

    case 'selectOption':
    case 'createOption':
    case 'removeOption':
    case 'blur': {
      setLocalValue(newValue);

      if (newValue) {
        const mappedNewValue = Array.isArray(newValue)
          ? newValue.map(({ value }) => value)
          : [newValue.value];

        handleChange(
          {
            key: name,
            value: isTMultipleValue(currentValue, mappedNewValue) ? mappedNewValue : defaultValue,
          },
          availableValues,
        );
      } else {
        handleChange(defaultValueObj, availableValues);
      }

      break;
    }

    default: {
      const x: never = reason;

      throw new Error(EXCEPTIONS_MESSAGE.notHandledKey(x));
    }
  }
};
